import React, { useEffect, useState } from 'react';
import {useParams} from "react-router-dom";
import {getGamesAction, getGamesAdventure, getGamesTerror, getGamesSport} from "../Queries/getGames";
import {ColumnGames} from "../layout/Interface";
import Game from "./Game";

const Categorie = ({history}) => {
    const {categorie} = useParams();
    const [values, setValues] = useState([]);
    const [deleteGame, setDelete] = useState(false);

    useEffect(async () => {
        if(categorie == "accion"){
            const result =  await getGamesAction();
            setValues(result);
        }
        else if(categorie == "terror"){
            const result = await getGamesTerror();
            setValues(result);
        }
        else if(categorie == "aventura"){
            const result = await getGamesAdventure();
            setValues(result);
        }
        else if(categorie == "deporte"){
            const result = await getGamesSport();
            setValues(result);
        }
        setDelete(false);

    }, [deleteGame]);


    return (
        <div className = "bg-categorie">
            <div className="container p-1">
                <h1 className = "title white m-0">Juegos de {categorie} registrados</h1>
                <div className="flex-center">
                    <ColumnGames>
                        {
                            values.map(game => (
                                <Game key = {game.id} game = {game} setDelete = {setDelete}/>
                                ))
                            }
                    </ColumnGames>
                </div>
            </div>
        </div>
    );
}
 
export default Categorie;
